$(document).ready(function () {
    var selected_item_counter = 0;
    var bundle_cart_products = [];
    
    function showDefaultProgressMarkup()
    {
        $('.discount_text_1,.discount_text_2').removeClass('hidden');
        $('.wi_bundle_success_text').addClass('hidden');
    }


    function loadSuccessProductsMarkup (bundle_cart_products) {

        var success_products_markup = '';
        for (let i = 0; i < bundle_cart_products.length; i++) {
            const product = bundle_cart_products[i];
            success_products_markup += `
            <div class="grid__item bundle_product_grid__item">
                <div class="card">
                    <div class="card--image">
                        <img src="${product.product_image}" alt="${product.product_title}">
                    </div>
                    <div class="card--content">
                        <h3 class="card--title">${product.product_title}</h3>
                        <p class="card--vendor">${product.product_vendor}</p>
                    </div>
                </div>
            </div>`;
        }

        $('.wi_bundle_products_list').html(success_products_markup);
    }
    function updateBundleProgressBar() 
    {
        var selected_items = $('.bundle_product_grid__item.selected');
        showDefaultProgressMarkup();
        if (selected_items.length < 10) 
        {
            $('.wi_total_discount').text('10%');
            $('.wi_total_product').text(10 - selected_items.length);
        }
        else if (selected_items.length < 15 && selected_items.length >= 10)
        {
            $('.wi_total_discount').text('15%');
            $('.wi_total_product').text(15 - selected_items.length);
        }
        else if (selected_items.length < 20 && selected_items.length >= 15)
        {
            $('.wi_total_discount').text('20%');
            $('.wi_total_product').text(20 - selected_items.length);
        }    
        else if(selected_items.length >= 20)
        {
            $('.discount_text_1,.discount_text_2').addClass('hidden');
            $('.wi_bundle_success_text').removeClass('hidden');
        }

        if(selected_items.length == 20)
        {
            var progress = (selected_items.length / 20) * 100;
            $('.wi_test_discount_progress_bar').css('width', progress + '%');
        }
        else
        {
            var progress = (selected_items.length / 20) * 100;
            $('.wi_test_discount_progress_bar').css('width', progress + '%');
        }
    }

    
    
    $(document).on('click','.bundle_product_grid__item',function () 
    {
        if ($(this).parents('.wi_bundle_success').length > 0)
        {
            return false;
        }

        $('.wi_error_message').addClass('hidden');
        if ($(this).hasClass('selected')) {
            $(this).removeClass('selected');
            selected_item_counter--;
            $(this).find('.card--image-animate').removeClass('wi_active_border');
            $(this).find('.card-information__button button').text('Select');
            $(this).find('.wi_selected_item').removeClass('active_selected_item');
            $(this).find('.true_sign').removeClass('active_true_sign');
            $(this).find('.card-information__button button').removeClass('selected_button');
            updateBundleProgressBar();

        }
        else {
            $(this).addClass('selected');
            selected_item_counter++;
            $(this).find('.card-information__button button').text('Selected');
            $(this).find('.card--image-animate').addClass('wi_active_border');
            $(this).find('.wi_selected_item').addClass('active_selected_item');
            $(this).find('.true_sign').addClass('active_true_sign');
            $(this).find('.card-information__button button').addClass('selected_button');
            updateBundleProgressBar();

        }
    });

    async function removeExistingBundle(cb) 
    {   
        var updates = {};
        await $.ajax({
            url: '/cart.js',
            type: 'GET',
            dataType: 'json',
            success: function(cart)
            {
                //  check if cart.items has properties._type == 'bundle_product'
                var items = cart.items;
                
                for (let i = 0; i < items.length; i++) {
                    const item = items[i];
                    if (item.properties._type == 'bundle_product') {
                        updates[item.variant_id] = 0;
                    }
                }
            }   
          });

          await $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: {
                updates
            },
            dataType: 'json',
            success: function (data) {
                cb()
            }
        });

        
    }

    
    $('.wi_bundle_add_to_cart').click(function (e) {
        e.preventDefault();

        if (selected_item_counter < 10) {
            $('.wi_error_message').removeClass('hidden');
            return false;
        }

        $('.wi_bundle_add_to_cart').addClass("adding-to-cart-effect");

        removeExistingBundle(function() {

            var selected_items = $('.bundle_product_grid__item.selected');
            let formData = {
                'items': []
            };

            for (let i = 0; i < selected_items.length; i++) {
                const selected_item = selected_items[i];
                var variant_id = $(selected_item).attr('data-variant-id');
                formData.items.push({
                    'id': variant_id,
                    'quantity': 1, 
                    'properties': {
                        '_type': 'bundle_product'
                    }
                });

                bundle_cart_products.push({
                    'product_image': $(selected_item).attr('data-product-image'),
                    'product_title': $(selected_item).attr('data-product-title'),
                    'product_vendor': $(selected_item).attr('data-product-vendor'),
                });
            }

        
            $.ajax
                ({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: formData,
                    dataType: 'json',
                    success: function (data) {
                        console.log("items added to cart:::");
                        //  trigger click on cart-drawer
                        $('cart-drawer').trigger('click');
                        $('.wi_bundle_success').removeClass('hidden');
                        $('.wi_product_grid ').addClass('hidden');
                        $('.wi_bundle_success_cart').removeClass('hidden');
                        $('.discount_text_1').addClass('hidden');
                        $('.discount_text_2').addClass('hidden');
                        $('.wi_button_wrapper').addClass('hidden');
                        $('.pagination-wrapper').addClass('hidden');
                        $('.success_btn_wrapper ').removeClass('hidden');
                        loadSuccessProductsMarkup(bundle_cart_products);
                        $('html, body').animate({ scrollTop: $('.collection-hero__title').offset().top }, 'slow');
                        $('.wi_test_discount_progress_bar').css('width', '100%');
                        $('.wi_bundle_add_to_cart').removeClass("loading adding-to-cart-effect");
                    }
                });
            });

    });
});